import {Injectable} from '@angular/core';
import {AutoUnsubscribe} from '../../../../decorators/auto-unsubscribe.decorator';
import {IButtonSize, IWidgetPosition} from '../../../../common/models/interfaces';
import {Tunings} from '../../../../types/tunings';
import {
  ButtonSizes,
  buttonsSizeList,
  liveTranslationButtons,
  widgetButtons,
  widgetPosition,
  widgetPositionMobile,
} from './button.constants';

enum ColorPattern {
  solid = 'solid',
  gradient = 'gradient',
}

@Injectable({
  providedIn: 'root',
})
@AutoUnsubscribe()
export class ButtonService {
  widgetPosition: IWidgetPosition[] = widgetPosition;
  buttonsSizeList: IButtonSize[] = buttonsSizeList;
  widgetPositionMobile: IWidgetPosition[] = widgetPositionMobile;

  tunings: Partial<Tunings>;
  isGradient: boolean;
  firstColor = '#fff';
  linearGradient = '';
  selectedButton: number;
  iconSize: string;
  customTriggerEnabled: boolean;
  customTriggerSelector: string;
  position: number;
  positionMobile: number;
  positionNudge: string;
  positionNudgeMobile: string;
  selectedLiveTranslationButton: string;

  buttonSize: IButtonSize;
  public widgetButtonsList = widgetButtons;
  public liveTranslationButtonsList = liveTranslationButtons;

  public colorPattern: ColorPattern = ColorPattern.solid;

  initButtonData(tunings: Partial<Tunings>): void {
    this.isGradient = !!tunings?.widget_color_gradient && tunings?.widget_color_gradient !== 'off';
    this.colorPattern = this.isGradient ? ColorPattern.gradient : ColorPattern.solid;
    this.firstColor = tunings?.widget_color || '#0048FF';
    this.selectedButton = +tunings?.widget_icon_type || 1;
    this.customTriggerEnabled = tunings?.widget_custom_trigger_enabled;
    this.customTriggerSelector = tunings?.widget_custom_trigger || 'accessibilityWidget';
    this.position = +tunings?.widget_position || 1;
    this.positionMobile = tunings?.widget_position_mobile ? +tunings.widget_position_mobile : this.position || 1;
    this.positionNudge = tunings?.widget_position_nudge;
    this.positionNudgeMobile = tunings?.widget_position_nudge_mobile;
    this.iconSize = tunings?.widget_icon_size ? tunings.widget_icon_size.toLowerCase() : ButtonSizes.small;
    this.linearGradient = this.isGradient ? tunings?.widget_color_gradient : null;
    this.tunings = tunings;
  }

  updateButtonSize(): void {
    this.buttonSize = this.buttonsSizeList.find((s: IButtonSize) => s.sizeName === this.iconSize);
    this.widgetButtonsList.map(item => {
      item.size = this.buttonSize?.width;
      if (item.id === 4) {
        item.width = this.buttonSize?.textButtonWidth;
        item.height = this.buttonSize?.textButtonHeight;
      }
    });
    this.liveTranslationButtonsList.map(item => {
      item.size = this.buttonSize?.width;
    });
  }

  contrast(colorInHex: string): string {
    if (!colorInHex || colorInHex.length < 7 || typeof colorInHex !== 'string') {
      return '#FFFFFF';
    }
    const R_HEX: string = colorInHex.substr(1, 2);
    const G_HEX: string = colorInHex.substr(3, 2);
    const B_HEX: string = colorInHex.substr(5, 2);
    const R_DEC: number = parseInt(R_HEX, 16);
    const G_DEC: number = parseInt(G_HEX, 16);
    const B_DEC: number = parseInt(B_HEX, 16);

    const contrast = 1 - (0.299 * R_DEC + 0.587 * G_DEC + 0.114 * B_DEC) / 255;
    return contrast < 0.5 ? '#000000' : '#FFFFFF';
  }

  clearData() {
    this.tunings = null;
    this.isGradient = null;
    this.firstColor = '#fff';
    this.linearGradient = '';
    this.selectedButton = null;
    this.iconSize = null;
    this.customTriggerEnabled = null;
    this.customTriggerSelector = null;
    this.position = null;
    this.positionMobile = null;
    this.positionNudge = null;
    this.positionNudgeMobile = null;
    this.selectedLiveTranslationButton = null;
  }
}
